import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { SchedulerInstaller } from '@progress/kendo-scheduler-vue-wrapper'
Vue.use(SchedulerInstaller)
import chat from './modules/chat.js';

import modal from './modules/modal.js';
import message from './modules/message.js';

import categories from './modules/categories.js';
import faqcategories from './modules/faqcategories.js';
import organizations from './modules/organizations.js';
import faqs from './modules/faqs.js';
import tags from './modules/tags.js';
import users from './modules/users.js';
import support from './modules/support.js';
import posts from './modules/posts.js';
import comments from './modules/comments.js';
import mediauploads from './modules/mediauploads.js';
import metatag from './modules/metatag.js';
import termsandconditions from './modules/terms_and_conditions.js';
import tasks from './modules/tasks.js';
import teams from './modules/teams.js';
import quick_task from './modules/quick_task';
import caseStudy from './modules/casestudy';
import userGuide from './modules/userguide.js';
import events from './modules/event.js';
import brochures from './modules/brochure.js';
import webinar from './modules/webinar.js';
import persist from './modules/persist.js';
import VuexPersist from 'vuex-persist';
import { event } from 'jquery';


const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: (state) => ({
    persist: state.persist
  }),
});

export default new Vuex.Store({
  modules: {
    chat,
    modal,
    message,
    organizations,
    categories,
    tags,
    users,
    support,
    posts,
    faqcategories,
    faqs,
    comments,
    mediauploads,
    metatag,
    termsandconditions,
    tasks,
    teams,
    quick_task,
    caseStudy,
    userGuide,
    events,
    brochures,
    webinar,
    persist
  },
  plugins: [vuexLocalStorage.plugin]
});
